module.exports = __webpack_public_path__ + "media/סוכריה.2d7eb447.mp3";